import React, { useEffect } from "react";
import "./style.scss";
import {
  useTranslation,
  WithTranslation,
  withTranslation,
} from "react-i18next";
import { Button, Col, Row } from "antd";
import { RouteComponentProps } from "react-router-dom";
import { POLICY, ROUTER_PATH } from "../../common/constant";
import { setTitlePage } from "../../utils/helper";
import { localizeRouteKey } from "../../shared/helpers";

interface IProps extends RouteComponentProps<any>, WithTranslation {}

const PolicyAndGeneralTerms = (props: IProps) => {
  const { t } = useTranslation();

  useEffect(() => {
    setTitlePage(t("title_page_policy"));
  }, []);

  const handleClick = (p: any) => {
    setTitlePage(p.label);
    props.history.push(
      localizeRouteKey(ROUTER_PATH.POLICY_AND_GENERAL_TERMS) + t(p.type)
    );
  };

  const policyList = [
    // {
    //   type: POLICY.HELP_PAYMENT,
    //   label: t("help_payment_label"),
    // },
    // {
    //   type: POLICY.HELP_SHIPING,
    //   label: t("help_shiping_label"),
    // },
    {
      type: POLICY.TRADING_TERMS,
      label: t("trading_terms_label"),
    },
    {
      type: POLICY.HELP_SECURITY,
      label: t("help_security_label"),
    },
    {
      type: POLICY.HELP_GUARANTEE,
      label: t("help_guarantee_label"),
    },
    // {
    //   type: POLICY.HELP_SECURITY_PAYMENT,
    //   label: t("help_security_payment_label"),
    // },
  ];

  return (
    <Row className="kd-policy-wrap">
      <Col>
        <div className="kd-policy-title">
          <span className="main-title">{t("policy_title")}</span>
        </div>
        <div style={{ display: "flex", flexDirection: "column" }}>
          {policyList.map((p, i) => (
            <Button
              key={i}
              className="kd-policy-item main-content"
              type="link"
              block
              onClick={() => handleClick(p)}>
              <span>
                {i + 1}. {p.label}
              </span>
            </Button>
          ))}
        </div>
      </Col>
    </Row>
  );
};

export default withTranslation()(PolicyAndGeneralTerms);
